var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBlockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.092,
    height: 14.515,
    viewBox: "0 0 17.092 14.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e02a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be0031"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4826",
    "data-name": "Trazado 4826",
    d: "M-7702.181,312.64a.3.3,0,0,1,.4,0,.3.3,0,0,1,0,.4l-13.672,13.939a.239.239,0,0,1-.2.1.287.287,0,0,1-.2-.1.3.3,0,0,1,0-.4Zm-3.5,7.037a3.109,3.109,0,0,1-3.134,3.135.3.3,0,0,1-.3-.3.272.272,0,0,1,.3-.267,2.547,2.547,0,0,0,2.567-2.568.294.294,0,0,1,.267-.3A.3.3,0,0,1-7705.683,319.677Zm-5.7.267a.294.294,0,0,1-.267.3.3.3,0,0,1-.3-.3,3.11,3.11,0,0,1,3.135-3.135.3.3,0,0,1,.3.3.272.272,0,0,1-.3.267A2.548,2.548,0,0,0-7711.385,319.944Zm-5.9-.167c.133-.2,3.835-4.936,8.471-4.936a7.252,7.252,0,0,1,1.734.267h.034c.166.067.267.2.2.367a.276.276,0,0,1-.333.2h-.067a4.987,4.987,0,0,0-1.567-.267c-3.869,0-7.17,3.7-7.9,4.536a7.6,7.6,0,0,0,1.934,1.8c.2.133.434.3.734.5a.281.281,0,0,1,.067.4.252.252,0,0,1-.234.133.254.254,0,0,1-.167-.067,8.455,8.455,0,0,1-.733-.534,6.88,6.88,0,0,1-2.168-2.034A.261.261,0,0,1-7717.288,319.777Zm5.936,4.368a.268.268,0,0,1,.334-.2,7.613,7.613,0,0,0,2.2.267c3.868,0,7.136-3.434,7.87-4.268a20.273,20.273,0,0,0-2.635-2.335.272.272,0,0,1-.066-.4.3.3,0,0,1,.4-.033,16.143,16.143,0,0,1,2.9,2.6.26.26,0,0,1,0,.367,16.236,16.236,0,0,1-2.467,2.3,10.313,10.313,0,0,1-6,2.333,7.808,7.808,0,0,1-2.368-.3A.249.249,0,0,1-7711.352,324.145Z",
    transform: "translate(7717.363 -312.565)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlockIcon);
export default __webpack_public_path__ + "static/media/EyeBlockIcon.654768c8816dcd7a49fb7b3153420376.svg";
export { ForwardRef as ReactComponent };